<template>
  <v-app class="pa-3 mobile-view">
    <v-overlay
      :opacity="1"
      :value="overlay"
      color="#fff"
    >
      <v-progress-circular
        indeterminate
        size="130"
        :width="2"
        color="pink darken-1"
      >
        <v-img
          v-if="$brand === 'abriron'"
          width="80"
          src="@/assets/loader.gif"
        />
      </v-progress-circular>
    </v-overlay>
    <v-app-bar
      class="px-5"
      app
      flat
    >
      <a
        href="http://abriron.com"
        target="_blank"
      >
        <v-img
          v-if="$brand === 'abriron'"
          width="70"
          height="70"
          contain
          style="justify-items: start"
          class="mt-9 px-2"
          :src="logoBrand"
        />
        <v-img
          v-if="$brand !== 'abriron'"
          width="60"
          class="pt-3 px-2"
          :src="logoBrand"
        />
      </a>
      <v-spacer />
      <language v-model="lang" />
    </v-app-bar>
    <v-main>
      <v-container
        fluid
      >
        <v-card
          class="mx-auto justify-center mb-6"
          :max-width="(isMobile ? 380 : 500)"
          :class="{'pa-6': !isMobile}"
          style="border-radius: 10px"
          :elevation="(isMobile ? 0 : 10)"
          :flat="isMobile"
        >
          <v-row
            class="mt-6"
            :class="{'mx-0':!isMobile}"
          >
            <v-card-title
              class="justify-start my-1  py-1"
              grey
              :style="{'margin-top':(isMobile ? '40px !important' : '0px')}"
              darken-3
            >
              <h2>{{ $t('Login') }}</h2>
            </v-card-title>
            <div
              v-if="has_error"
              style="width: 100%"
            >
              <v-alert
                small
                text

                type="error"
              >
                {{ text_error }}
              </v-alert>
            </div>
            <v-col
              class="px-4  xs py-4 mb-0"
              cols="12"
            >
              <v-text-field
                v-model="username"
                :label="$t('username')"
                append-icon="mdi-account"
                :autocomplete="false"
                height="45"
                hide-details
                outlined
              />
            </v-col>

            <v-col
              class="px-4  xs py-0 mb-0"
              cols="12"
            >
              <v-text-field
                ref="refPassword"
                v-model="password"
                :type="(showPassword ? 'text' : 'password')"
                :label="$t('password')"
                :append-icon="(showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline')"
                height="45"
                outlined
                @click:append="showPassword = !showPassword"
              />
            </v-col>
            <v-col
              class="px-4  xs py-0 mb-0"
              cols="12"
            >
              <v-select
                v-if="showKeyItems"
                v-model="appKey"
                :items="keyItems"
                :label="$t('business-name')"
                append-icon="mdi-cloud"
                height="45"
                item-text="name"
                item-value="app_key"
                outlined
              />
            </v-col>
            <v-col
              class="px-4  xs py-0 mb-0"
              cols="12"
            >
              <v-select
                v-if="yearItems && yearItems.length > 1"
                v-model="year"
                :items="yearItems"
                :label="$t('Year')"
                append-icon="mdi-calendar-month"
                item-text="name"
                item-value="id"
                height="45"
                outlined
              />
            </v-col>
            <v-col
              class="px-4  xs pt-0"
              cols="12"
            >
              <v-btn
                v-shortkey="['enter']"
                :loading="loading"
                block
                color="primary"
                height="45"
                @click="submit"
                @shortkey="submit"
              >
                <p
                  style="font-size: 16px"
                  class=" text-center mb-0"
                >
                  {{ $t('Login') }}
                </p>
              </v-btn>
            </v-col>
            <v-col
              class="xs py-0 px-4"
              style="display: flex"
              cols="12"
              md="12"
              sm="12"
            >
              <v-btn
                color="#fff"
                class="mx-2 mt-1 ps-0 ms-0 pOrrange--text"
                text
                style="font-size: 15px;padding-right: 18px;padding-left: 20px"
                small
                @click="goTo('register')"
              >
                {{ $t('register') }}
              </v-btn>
              <v-spacer />
              <div
                class="mx-auto justify-center blue-grey--text text--darken-3 mt-2"
                style="cursor: pointer;font-size: 12px"
                @click="goTo('forgetPassword')"
              >
                {{ $t('forgetPassword') }}
              </div>
            </v-col>
            <v-col
              class="xs py-0"
              style="display: flex"
              cols="12"
              md="12"
              sm="12"
            />
            <v-col cols="12" />
          </v-row>
        </v-card>
      </v-container>
    </v-main>
    <v-footer
      class="py-2"
      style="font-size: 12px;"
      padless
    >
      <v-col
        class="text-center py-1"
        cols="12"
      >
        {{ new Date().getFullYear() }} — Abriron Cloud Panel V {{ env.version }}
      </v-col>
    </v-footer>
    <v-dialog
      v-model="errorDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="errorDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <div class="mb-1 text-center">
          <p v-text="errorMessage" />
        </div>
        <v-col class="py-1">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>
                    {{ $t('device') }}
                  </th>
                  <th>
                    {{ $t('action') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in errorData"
                  :key="item.id"
                >
                  <td class="pa-3">
                    {{ item.ua }}
                  </td>
                  <td>
                    <v-btn
                      color="pink"
                      icon
                      class="float-left"
                      @click="logout(item)"
                    >
                      <v-icon>
                        mdi-delete-outline
                      </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col
              cols="6"
              class="pa-0"
            />
            <v-col
              cols="6"
              class="pa-0"
            >
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="errorDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : '')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import Language from '../components/core/LanguageBar'
import General from '../../../Mixins/general'
export default {
  components: {
    Language
  },
  mixins: [General],
  props: ['appkeyProp', 'usernameProp', 'passwordProp', 'shopProp'],
  data () {
    return {
      lang: null,
      overlay: true,
      yearItems: null,
      year: null,
      showKeyItems: false,
      appKey: null,
      showPassword: null,
      username: null,
      keyItems: null,
      password: null,
      has_error: false,
      text_error: null,
      loading: false
    }
  },
  beforeMount () {
    if (location.host === 'app.abriron.com') {
      this.$router.push('/mlogin')
    }
    if (this.usernameProp) {
      this.username = this.usernameProp
    }
    if (this.passwordProp) {
      this.password = this.passwordProp
      // this.submit()
      this.overlay = false
    } else {
      this.overlay = false
    }
  },
  methods: {
    submit () {
      if (!this.username || !this.password) {
        this.has_error = true
        this.text_error = this.$t('enterTheLoginInformationCorrectly')
        this.loading = false
        return false
      }
      const app = this
      app.has_error = false
      app.loading = true
      app.$axios.defaults.headers.common.domain = app.appKey
      // app.$axios.defaults.headers.common.withCredentials = true
      this.$axios.get(this.$apipoint + 'login', {
        params: {
          year: this.year,
          username: this.username,
          password: this.password,
          lang: (this.lang ? this.lang.lang : 'en')
        }
      }).then(function (response) {
        if (response.data.keys) {
          app.keyItems = null
          app.keyItems = response.data.keys
          if (app.keyItems.length === 1) {
            app.appKey = app.keyItems[0].app_key
            app.submit()
          } else {
            app.showKeyItems = true
            app.snakbarText = app.$t('chooseBusinessName')
            app.snakbarColor = 'primary'
            app.snakbar = true
            app.loading = false
          }
        } else {
          localStorage.setItem('user', response.data.meta)
          localStorage.setItem('fullname', response.data.name)
          app.$axios.defaults.headers.common.Authorization = 'Bearer ' + response.data.meta.token
          localStorage.setItem('token', JSON.stringify(response.data.meta))
          localStorage.setItem('APP_KEY', app.appKey)
          var keyItems = []
          var storedKeyItems = localStorage.getItem('APP_KEY_ITEMS')
          keyItems.push(app.appKey)
          keyItems.push(storedKeyItems)
          localStorage.setItem('APP_KEY_ITEMS', keyItems)
          // store mutation
          app.$store.commit('SET_FULLNAME', response.data.name)
          app.$store.commit('SET_CURRENCY_SYMBOL', response.data.meta.init.currencySymbol)
          app.$store.commit('SET_FINANCIALYEAR', response.data.meta.init.financialYear)
          app.$store.commit('SET_BACKGROUNDIMAGE', response.data.meta.init.backgroundImage)
          app.$store.commit('SET_BACKGROUNDCOLOR', response.data.meta.init.backgroundColor)
          app.$store.commit('SET_START_DATE', response.data.meta.init.startDate)
          app.$store.commit('SET_END_DATE', response.data.meta.init.endDate)
          app.$store.commit('SET_THEME_COLOR', response.data.meta.init.theme_color.value)
          app.$store.commit('SET_DARK', response.data.meta.init.dark.value)
          app.$store.commit('SET_HOVERMENU', response.data.meta.init.hoverMenu.value)
          app.$store.commit('SET_APPBARSOPACITY', response.data.meta.init.appBarsOpacity.value)
          app.$store.commit('SET_ACCESS', response.data.meta.init.access)
          app.$store.commit('SET_LANG', response.data.meta.init.lang.value)
          app.$store.commit('SET_RTL', response.data.meta.init.rtl.value)
          app.$store.commit('SET_DATE_LOCALE', response.data.meta.init.date_locale.value)
          app.$store.commit('SET_NEGATIVE_INVENTORY', response.data.meta.init.negative_inventory.value)
          app.$store.commit('SET_CURRENCY', response.data.meta.init.currency)
          app.$store.commit('SET_MENU_BOOKMARK', response.data.meta.init.menuBookmark)
          app.$store.commit('SET_PERMISSIONS', response.data.meta.init.permissions)
          if (response.data.meta.init.teacherAccess) {
            app.$store.commit('SET_TEACHERACCESS', 'active')
          }
          // if (response.data.meta.year.length > 1 && !app.year) {
          //   app.loading = false
          //   app.snakbarText = app.$t('chooseYear')
          //   app.snakbarColor = 'primary'
          //   app.snakbar = true
          //   app.yearItems = response.data.meta.year
          // } else {
          //
          // }
          var lastPath = localStorage.getItem('last_path')
          if (lastPath && lastPath !== 'null' && location.host !== 'app.abriron.com') {
            localStorage.setItem('last_path', null)
            app.$router.push({ path: lastPath })
          } else {
            // app.$router.push('home')
            if (app.shopProp) {
              app.$router.push({ path: 'shop/initialize' })
            } else {
              if (response.data.meta.init.teacherAccess) {
                app.$router.push({ name: 'academyDashboard' })
              } else {
                if (app.$route.name === 'mlogin' || app.$route.name === 'mlogout') {
                  localStorage.setItem('apn', 'active')
                  app.$router.push({ name: 'mDashboard' })
                } else {
                  localStorage.setItem('apn', null)
                  app.$router.push('/')
                }
              }
            }
          }
        }
      }).catch(err => {
        app.loading = false
        this.serverErrorHandeler(err)
      }).finally(function () {
        app.overlay = false
      })
    },
    logout (item) {
      var index = this.errorData.indexOf(item)
      this.errorData.splice(index, 1)
      this.$socket.emit('logout', item.socket_id)
      if (this.errorData.length === 0) {
        this.errorDialog = false
        this.submit()
      }
    },
    onClickRegisterBtn () {
      this.$router.push({ name: 'register' })
    }
  }

}
</script>

<style  lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'
.mobile-view
  .v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer, .v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner, .v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner, .v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer, .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer, .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner, .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner, .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer
    margin-top: 13px
  .v-text-field--outlined .v-label
    top: 12px
</style>
